import React, { useState } from 'react';
import { FaEye, FaEyeSlash, FaExclamationTriangle } from 'react-icons/fa';

interface MaskedBlockProps {
  children: React.ReactNode;
  reason?: string;
  isBlocked?: boolean;
  className?: string;
}

export default function MaskedBlock({ 
  children, 
  reason = 'Contenu potentiellement inapproprié',
  isBlocked = false,
  className = '' 
}: MaskedBlockProps) {
  const [isRevealed, setIsRevealed] = useState(false);

  if (isRevealed) {
    return (
      <div className={`relative ${className}`}>
        {children}
        <button
          onClick={() => setIsRevealed(false)}
          className="absolute top-2 right-2 p-1 bg-gray-800/80 rounded-full hover:bg-gray-700/80 transition-colors duration-200"
        >
          <FaEyeSlash className="w-3 h-3 text-gray-400" />
        </button>
      </div>
    );
  }

  return (
    <div className={`relative bg-gray-800/30 border border-red-500/30 rounded-lg p-4 ${className}`}>
      {/* Warning Banner */}
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-8 h-8 bg-red-500/20 rounded-full flex items-center justify-center flex-shrink-0">
          <FaExclamationTriangle className="w-4 h-4 text-red-400" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-red-300">
            {isBlocked ? '⚠️ Contenu masqué (Règles)' : '⚠️ Ce passage est potentiellement choquant.'}
          </p>
          <p className="text-xs text-gray-400 mt-1">{reason}</p>
        </div>
      </div>

      {/* Reveal Button */}
      {!isBlocked && (
        <button
          onClick={() => setIsRevealed(true)}
          className="flex items-center space-x-2 px-4 py-2 bg-gray-700/50 hover:bg-gray-600/50 rounded-lg text-sm font-medium text-white transition-colors duration-200 border border-gray-600/30"
        >
          <FaEye className="w-4 h-4" />
          <span>Afficher quand même</span>
        </button>
      )}

      {/* Community Guidelines Link */}
      <div className="mt-3 pt-3 border-t border-gray-600/30">
        <a
          href="/community-guidelines"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-blue-400 hover:text-blue-300 underline"
        >
          Règles de la communauté
        </a>
      </div>

      {/* Hidden content for screen readers */}
      <div className="sr-only">
        {children}
      </div>
    </div>
  );
}